/**
 * Returns true if the given item is a session with a display category.
 * @param {object} item - The item to check.
 * @return {boolean} Returns true if the item is a session with a display category.
 */
export function hasDisplayCategory(item) {
    return !!item.display_category;
}
